import ArrowLeft from '@images/svg-icons/arrowLeft.svg';
import InfoIconSmall from '@images/svg-icons/infoIconSmall.svg';

import * as actions from '@redux-actions/';
import { RootState } from 'src/store/store';
import { getLabelFallback } from '@utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import SavedPrescriptionForm from '../prescription-form/SavedPrescriptionForm';
import LastUpdate from './LastUpdate';

const SavedPrescriptionCardContent = () => {
    const mySavedPrescriptions = useSelector(
        (state: RootState) => state.contacts.mySavedPrescriptions
    );
    const currentPrescription = useSelector(
        (state: RootState) => state.contacts.currentPrescription
    );

    const dispatch = useDispatch();

    //check if left and right eye have the same CL pack brand
    const isTwoProducts =
        !!currentPrescription.leftCatentryParentId && !!currentPrescription.rightCatentryParentId;
    const isSameProduct =
        currentPrescription.leftCatentryParentId === currentPrescription.rightCatentryParentId;

    return (
        <div className="saved-prescription-content">
            <div className="saved-prescription-info-container">
                <div role="region" aria-label="card title" className="card-title">
                    {mySavedPrescriptions?.length > 1 && (
                        <button
                            className="breadcrumb"
                            onClick={() => dispatch(actions.setCurrentPrescription(null))}
                            data-analytics_available_call="0"
                        >
                            <ArrowLeft className="back-icon" /> Back
                        </button>
                    )}
                    <div className="title-container">
                        <span className="title-username">
                            {getLabelFallback('MY_SAVED_PRESCRIPTION_PRESCRIPTION_NAME_LABEL')}:{' '}
                            <b>
                                {currentPrescription.firstName} {currentPrescription.lastName}
                            </b>
                        </span>{' '}
                        <span className="title-date">
                            <LastUpdate prescription={currentPrescription} />
                        </span>
                    </div>
                </div>
            </div>

            {isTwoProducts && !isSameProduct && (
                <div className="alert">
                    <InfoIconSmall className="icon" />

                    <span className="text">
                        Your prescription contains different products for each eye. If you want, you
                        can add the product for the other eye below.
                    </span>
                </div>
            )}

            <div className="contact-lens-prescription">
                <SavedPrescriptionForm />
            </div>
        </div>
    );
};

export default SavedPrescriptionCardContent;
